import { createSelector, Selector } from 'reselect';

import { ProfileIdentificationStatusAPIModel } from '@/generated/api/fps/api';
import { RootState } from '@/model/types';

import { Confirmation, IdentificationState, PhoneValue } from './types';

export const makeSelectPhone = (): Selector<RootState, PhoneValue | undefined> =>
  createSelector(
    (state: RootState) => state.identification.phone,
    (phone) => phone,
  );

export const makeSelectIdentificationState = (): Selector<RootState, IdentificationState | undefined> =>
  createSelector(
    (state: RootState) => state.identification.state,
    (state) => state,
  );

export const makeSelectProfileIdentificationStatus = (): Selector<
  RootState,
  ProfileIdentificationStatusAPIModel | undefined
> =>
  createSelector(
    (state: RootState) => state.identification.profileIdentificationStatus,
    (state) => state,
  );

export const makeSelectConfirmationState = (): Selector<RootState, Confirmation | undefined> =>
  createSelector(
    (state: RootState) => state.identification.confirmation,
    (state) => state,
  );

export default {
  makeSelectPhone,
  makeSelectIdentificationState,
  makeSelectProfileIdentificationStatus,
  makeSelectConfirmationState,
};
